export enum WaiveMessages {
  WAIVE_MESSAGE = 'This evidence will no longer be required, and a decision can be made without it. Please provide a reason for waiving this evidence.',
  WAIVEL_LABEL = 'Waive Reason',
}
